export default "__VITE_ASSET__D3BBVruh__"